import { BlogPostContent } from "@/types/blog";
import { intro } from "./sections/intro";
import { koerperPassiert } from "./sections/koerper-passiert";
import { virusFuehrung } from "./sections/virus-fuehrung";
import { innererAntreiber } from "./sections/innerer-antreiber";
import { leistungskultur } from "./sections/leistungskultur";
import { praxis } from "./sections/praxis";
import { fazit } from "./sections/fazit";
import { quellen } from "./sections/quellen";

export const content: BlogPostContent = {
  sections: [
    intro,
    koerperPassiert,
    virusFuehrung,
    innererAntreiber,
    leistungskultur,
    praxis,
    fazit,
    quellen
  ]
};
